var exports = {
  "kL": "DiscoveryPage.module__container___R0ZoNU",
  "Gm": "DiscoveryPage.module__scrollBody___R0ZoNU",
  "Qs": "DiscoveryPage.module__content___R0ZoNU",
  "LB": "DiscoveryPage.module__browseLayout___R0ZoNU",
  "bK": "DiscoveryPage.module__searchLayout___R0ZoNU",
  "LG": "DiscoveryPage.module__resultsColumn___R0ZoNU",
  "Yt": "DiscoveryPage.module__resultsSurface___R0ZoNU",
  "qM": "DiscoveryPage.module__virtualGrid___R0ZoNU",
  "lJ": "DiscoveryPage.module__gridRow___R0ZoNU",
  "sw": "DiscoveryPage.module__loadingMore___R0ZoNU",
  "sM": "DiscoveryPage.module__srOnly___R0ZoNU",
};

module.exports = exports;
